import PublicLayout from "../../../layouts/PublicLayout";
import { useEffect, useState } from "react";
import api from "../../../configs/api";
import { StaticServicesData } from "./servicesData";
import Loader from "../../../common/Loader";

function OurServices() {

  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const setServicesFn = async () => {
    try {
      const servicesData = await api.get("/CMS/services");
      setServices(servicesData?.data);
      setIsLoading(false)
    } catch (error) {
      console.error("set theme error: ", error);
      setServices(StaticServicesData);
      setIsLoading(false)
    }
  };

  useEffect(() => {
    setServicesFn();
  }, []);


  return (
    <PublicLayout>
      <div className='md:h-[250px] h-[100px] flex justify-center items-center md:mb-0 mb-4 bg-landingImage2 bg-no-repeat bg-cover w-full bg-center'>
        <div className=''>
          <div className='max-w-[800px] w-full mx-auto text-center flex flex-col'>
            <p className='uppercase text-white md:text-5xl sm:text-4xl text-3xl font-bold p-4'>
              تعرف على خدمات ظل المتنوعة
            </p>
          </div>
        </div>
      </div>

      <div>
        <div className='min-h-[365px]'>
          <div className='flex flex-col mx-10 lg:mx-36'>
            <h1 dir='rtl' className='text-2xl mt-10  font-bold'>
              خدمات ظل المتنوعة
            </h1>
            <div className='text-lg font-bold' dir='rtl'>
              <br />
              تعرف على ابرز خدماتنا العلاجية و الـتربوية و التعليمية
            </div>
          </div>
          <div className='max-w-[1240px] mx-auto mt-12 mb-12 flex flex-row flex-wrap gap-5 justify-center'>

            {isLoading ?
              <Loader isFullScreen={false} />
              :
              <>
                {services?.map((service, index) => (
                  <div
                    key={index}
                    className='text-white font-bold cursor-pointer relative flex justify-center items-end h-[250px] w-[188px] shadow-sm'
                  >
                    <div className='absolute bg-gradient-to-b from-[#ffffff00] via-[#ffffff00] to-[--primary-color] z-10 h-full w-full rounded-lg'></div>

                    <img
                      src={service.image}
                      className='w-full h-full object-cover absolute rounded-lg'
                      alt='Doctor'
                    />
                    <h1 className='absolute z-20 text-white m-4 text-center h-[48px]'>
                      {service.title}
                    </h1>
                  </div>
                ))}

              </>
            }
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}

export default OurServices;
